import { useEffect, useRef } from "react";

/**
 * hook que armazena o valor de uma variável,
 * só atualizando quando tiver alguma diferença detectada
 * pela função compare
 * @param next valor que é monitorado e que pode ser
 * eventualmente retornado
 * @param compare função que compara dois valores, retorna true
 * se forem iguais
 * @returns valor memoizado, atualizado sempre que a
 * comparação falhar
 */
export function useMemoCompare<T>(
    next: T,
    compare: (val1: any, val2: any) => boolean
) {
    // Ref para armazenar valor anterior
    const previousRef = useRef<T>();
    const previous = previousRef.current;
    // Pass previous and next value to compare function
    // to determine whether to consider them equal.
    // Compara o valor antigo com novo usando a função
    // de compare recebida para ver se são iguais
    const isEqual = compare(previous, next);
    // If not equal update previousRef to next value.
    // We only update if not equal so that this hook continues to return
    // the same old value if compare keeps returning true.
    // Se não for igual, atualiza o valor armazenado
    useEffect(() => {
        if (!isEqual) {
            previousRef.current = next;
        }
    });
    // Se for igual, retorna o valor armazenado, se
    // se não retorna o valor novo
    return isEqual ? previous : next;
}
